// extracted by mini-css-extract-plugin
export default {"containerSustainability":"editSustainability_containerSustainability__AF4yJ"};